( function () {
	'use strict';

	function mcListCtrl ( apiService, logger, ppdFactory, $scope ) {
		var self = this;

		function attachOtherDetails ( item ) {
			item.name   = item.meta.title;
			item.mcType = item.type;
			item.type   = 3;

			return item;
		}

		function checkType ( item ) {
			return item.type !== 'premium' || item.type === 'premium' && item.premium;
		}

		function isSameObj ( item ) {
			return item.id === this.data.id;
		}

		function modifyAttachFlag ( item ) {
			item.isAttached = this.dataVal;

			return item;
		}

		function pdCommonListenerHandler ( event, item ) {
			self.source
				.filter( isSameObj.bind( { 'data' : item } ) )
				.map( modifyAttachFlag.bind( { 'dataVal' : this.attachFlagVal } ) );
		}

		function onSuccess ( mc ) {
			var attachedData = ppdFactory.getAttachedPDs();
			var recommended  = ppdFactory.getRecommendedPDs();

			self.source = ppdFactory.attachProps( attachedData, mc.data.filter( checkType ).map( attachOtherDetails ) );
			self.source = ppdFactory.attachProps( recommended, self.source );

			$scope.$parent.$on( 'ppd:remove', pdCommonListenerHandler.bind( { 'attachFlagVal' : false } ) );
			$scope.$parent.$on( 'ppd:add', pdCommonListenerHandler.bind( { 'attachFlagVal' : true } ) );
		}

		function onError ( error ) {
			logger.notifyError( error );
		}

		function removeLoading () {
			self.loading = false;
		}

		function activate () {
			self.loading = true;
			self.source  = [];

			apiService.mc.get()
				.then( onSuccess, onError )
				.finally( removeLoading );
		}

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'mcListCtrl', mcListCtrl );

	mcListCtrl.$inject = [ 'apiService', 'logger', 'ppdFactory', '$scope' ];
} )( );
